import './ai-assistant.css';

/**
 * 回答尚未出字时的等待动画：渐变呼吸点 + shimmer 状态文案。
 * 替代之前「空气泡里只有一个静态 ▍」的等待体验。
 */
const ThinkingIndicator = ({ text = '正在思考' }: { text?: string }) => (
  <span className="ai-thinking" data-testid="ai-thinking">
    <span className="ai-thinking-dots">
      <span className="ai-thinking-dot" />
      <span className="ai-thinking-dot" />
      <span className="ai-thinking-dot" />
    </span>
    <span className="ai-thinking-text">{text}…</span>
  </span>
);

export default ThinkingIndicator;
